import React, { useEffect, useState } from 'react';
import { AnalyticsResponse } from '../types';
import { useInterval } from '../hooks/useInterval';
import { useAuth } from '@clerk/clerk-react';
import { fetchAnalyticsData } from '../utils/backendServices';
import { AnalyticsContext } from '../contexts/AnalyticsContext';

interface AnalyticsContextProviderProps {
    children: React.ReactNode;
}
const AnalyticsContextProvider: React.FC<AnalyticsContextProviderProps> = ({
    children,
}) => {
    const [analyticsData, setAnalyticsData] =
        useState<AnalyticsResponse | null>(null);

    const [isLoading, setIsLoading] = useState<boolean>(true);

    const { orgId } = useAuth();

    const state = {
        analyticsData,
        isLoading,
    };

    const setters = {
        setIsLoading,
    };

    const handleAnalyticsRequest = async (showSpinner = true) => {
        if (showSpinner) {
            setIsLoading(true);
        }

        const newAnalyticsData = await fetchAnalyticsData();
        setAnalyticsData(newAnalyticsData);
        setIsLoading(false);
    };

    useEffect(() => {
        handleAnalyticsRequest();
    }, [orgId]);

    useInterval(() => {
        handleAnalyticsRequest(false);
    }, 120000);

    const refresh = (showSpinner = true) => {
        return handleAnalyticsRequest(showSpinner);
    };

    return (
        <AnalyticsContext.Provider value={{ state, setters, refresh }}>
            {children}
        </AnalyticsContext.Provider>
    );
};

export default AnalyticsContextProvider;
